import { useCurrentStateAndParams } from "@uirouter/react";
import type { FallbackProps } from "react-error-boundary";
import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";
import { useAutoScrollTop } from "app/custom-hooks/useAutoScrollTop";
import ConversionHomepageContainer from "app/pages/conversion/ConversionHomepageContainer";

const FallbackComponent = (props: FallbackProps) => (
    <ErrorFallback
        {...props}
        shouldLogErrorFallback={false}
    />
);

export const ConversionHomepageWrapper = () => {
    const autoScrollRef = useAutoScrollTop();
    const { state: currentState, params } = useCurrentStateAndParams();

    return (
        <ErrorBoundary
            FallbackComponent={FallbackComponent}
            resetKeys={[currentState, params]}
        >
            <div className="sw-layout-module-inner">
                <div
                    className="sw-layout-scrollable-element use-sticky-css-rendering fadeIn"
                    ref={autoScrollRef}
                >
                    <ConversionHomepageContainer />
                </div>
            </div>
        </ErrorBoundary>
    );
};
